// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2P5zX","itemTitle":"ClientEmergencyInfo_itemTitle__2e-ll","itemText":"ClientEmergencyInfo_itemText__2IUet"};